import { nanoid } from 'nanoid';

export const generateNanoid = () => nanoid();
